import PropTypes from "prop-types"
import React, { useRef, useState } from "react"
import { Autocomplete, useJsApiLoader } from "@react-google-maps/api"
import { casablancaBounds, isPlaceInCasablanca } from "../partnerSignupUtils"

const libraries = ["places"]

const GooglePlacesSearchInput = ({ onPlaceSelected }) => {
  const autocompleteRef = useRef(null)
  const [error, setError] = useState("")
  const apiKey = process.env.REACT_APP_GOOGLE_MAPS_API_KEY || ""
  const { isLoaded, loadError } = useJsApiLoader({
    id: "wevalo-partner-google-maps",
    googleMapsApiKey: apiKey,
    libraries,
    language: "fr",
  })

  const handlePlaceChanged = () => {
    const place = autocompleteRef.current?.getPlace()
    if (!place?.geometry?.location) return

    if (!isPlaceInCasablanca(place)) {
      setError("Sélectionnez un commerce situé à Casablanca.")
      return
    }

    setError("")
    onPlaceSelected(place)
  }

  if (!apiKey) {
    return (
      <div className="partner-alert partner-alert-warning">
        La recherche Google Places nécessite la variable <code>REACT_APP_GOOGLE_MAPS_API_KEY</code>.
      </div>
    )
  }

  if (loadError) {
    return <div className="partner-alert partner-alert-danger">Google Maps est momentanément indisponible.</div>
  }

  if (!isLoaded) {
    return <div className="partner-search-skeleton">Chargement de Google Maps...</div>
  }

  return (
    <>
      <Autocomplete
        onLoad={autocomplete => {
          autocompleteRef.current = autocomplete
        }}
        onPlaceChanged={handlePlaceChanged}
        fields={[
          "name",
          "formatted_address",
          "address_components",
          "geometry",
          "website",
          "place_id",
        ]}
        options={{
          bounds: casablancaBounds,
          componentRestrictions: { country: "ma" },
          strictBounds: true,
          types: ["establishment"],
        }}
      >
        <div className="partner-search-control">
          <i className="bx bx-search" aria-hidden="true" />
          <input
            type="search"
            aria-label="Rechercher votre commerce"
            placeholder="Nom du commerce ou adresse à Casablanca..."
            autoComplete="off"
          />
        </div>
      </Autocomplete>
      {error && <div className="partner-field-error partner-search-error">{error}</div>}
    </>
  )
}

GooglePlacesSearchInput.propTypes = {
  onPlaceSelected: PropTypes.func.isRequired,
}

export default GooglePlacesSearchInput
